module.exports = __webpack_public_path__ + "static/media/bmanagecomplaint.aa5dae53.svg";